import {
  FulfillmentOrderAddressSchema,
  type IFulfillmentOrderAddress,
} from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import * as z from "zod";

export const searchCustomers = {
  name: "searchCustomers" as const,
  input: z.object({ searchString: z.string() }),
  output: z.object({
    suggestions: z.array(
      FulfillmentOrderAddressSchema as IFulfillmentOrderAddress,
    ),
  }),
};
